import styled, {css} from "styled-components/macro";
import {device} from "../../styles";
import {IsVisibleOnMobile} from "../../data";

export const Root = styled.div<IsVisibleOnMobile>`
    display: flex;
    flex-direction: column;
    border: 1px solid var(--color-border-dropdown);

    ${device.less1180} {
        gap: 5px;
    }

    ${device.less768} {
        gap: 8px;
        border: none;
        display: none;
        
        ${(props) => props.$isVisibleOnMobile && css`
            display: flex;
        `}
    }
`;

export const Head = styled.div`
    min-height: 50px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    cursor: pointer;
    padding: 0 30px;
    user-select: none;

    ${device.less1180} {
        min-height: 42px;
        padding: 0 20px;
    }

    ${device.less768} {
        min-height: auto;
        cursor: default;
        padding: 0;
    }
`;

export const Title = styled.div`
    color: var(--color-accent);
    font-family: LatoWebSemibold, sans-serif;
    font-size: 16px;
    font-style: normal;
    line-height: 28px;
    text-transform: uppercase;
    
    ${device.less1180} {
        font-size: 12px;
    }
`;



export const Body = styled.div`
    transition: all 0.3s;
    padding: 15px 30px;

    ${device.less1180} {
        padding: 0 20px 15px 20px;
    }

    ${device.less768} {
        padding: 0;
    }
`;


export const Foot = styled.div`
    display: flex;
    flex-direction: column;
    gap: 30px;
    border-top: 1px solid var(--color-border-dropdown);
    padding: 20px 0 20px 0;
    margin: 0 30px;
    
    &:empty {
        display: none;
    }

    ${device.less1180} {
        padding: 20px 0;
        margin: 0 20px;
        gap: 25px;
    }

    ${device.less768} {
        padding: 0;
        margin: 0;
        border: none;
    }
`;
